package com.partejar.app.feature.contratos.presentation

import com.partejar.app.feature.contratos.data.CivilData
import com.partejar.app.feature.contratos.data.Contrato
import com.partejar.app.feature.relacionamentos.data.RelationshipDetail
import kotlinx.datetime.LocalDate

enum class ContractPreparationStep(val title: String) {
    PREGNANCY("Gestação"),
    PATIENT("Dados"),
    CONTRACT("Contrato"),
    REVIEW("Revisão")
}

data class ContractPreparationProgress(
    val steps: List<ContractPreparationStep>,
    val currentIndex: Int = 0,
    val completed: Set<ContractPreparationStep> = emptySet(),
    val active: Boolean = steps.size > 1
) {
    val current: ContractPreparationStep get() = steps[currentIndex.coerceIn(steps.indices)]

    fun complete(step: ContractPreparationStep): ContractPreparationProgress {
        if (step != current) return this
        val nextCompleted = completed + step
        val nextIndex = (currentIndex + 1).coerceAtMost(steps.lastIndex)
        return copy(currentIndex = nextIndex, completed = nextCompleted)
    }

    fun finish() = copy(completed = completed + current, active = false)
}

internal fun contractPreparationProgress(
    contract: Contrato,
    civil: CivilData,
    patient: RelationshipDetail
): ContractPreparationProgress = ContractPreparationProgress(
    steps = buildList {
        if (!contractPrerequisitesReady(patient.babyName, patient.dueDate)) {
            add(ContractPreparationStep.PREGNANCY)
        }
        if (civil.cpf.isNullOrBlank() || civil.email.isNullOrBlank()) {
            add(ContractPreparationStep.PATIENT)
        }
        if (contract.planVersionId == null || contract.modelVersionId == null || contract.signerIds.isEmpty()) {
            add(ContractPreparationStep.CONTRACT)
        }
        add(ContractPreparationStep.REVIEW)
    }
)

internal fun contractPrerequisitesReady(babyName: String?, dueDateIso: String?): Boolean =
    !babyName.isNullOrBlank() && !dueDateIso.isNullOrBlank() &&
        runCatching { LocalDate.parse(dueDateIso) }.isSuccess
